/**
 * Legal-Konstanten — URLs und AGB-Versionierung (#245).
 *
 * Single Source of Truth fuer alle AGB-/Widerrufs-bezogenen Werte im Frontend.
 * Aenderungen hier wirken sich auf LoginPage, EmailForm, AgbUpdateModal und
 * DataDisclaimerBadge (via disclaimers.js Re-Export) aus.
 *
 * `CURRENT_AGB_VERSION` muss mit `src/config.py::CURRENT_AGB_VERSION` synchron
 * bleiben. Major-Bump (z.B. "1.0" -> "2.0") loest Re-Akzeptanz aus
 * (siehe needsAgbReacceptance im AuthContext, Chunk E rendert das Modal).
 */

export const AGB_URL = 'https://www.mein-gruenraum.de/agb';
export const WIDERRUF_URL = 'https://www.mein-gruenraum.de/widerruf';
export const DATENSCHUTZ_URL = 'https://www.mein-gruenraum.de/datenschutz';

export const CURRENT_AGB_VERSION = '1.0';

/**
 * Vergleicht zwei AGB-Versionen auf Major-Ebene.
 *
 * "1.0" vs "1.1" -> false (Minor-Bump, keine Re-Akzeptanz)
 * "1.0" vs "2.0" -> true  (Major-Bump, Re-Akzeptanz erforderlich)
 * null/undefined -> true  (z.B. Bestands-User vor AGB-Einfuehrung)
 *
 * @param {string|null|undefined} userVersion
 * @param {string} currentVersion
 * @returns {boolean}
 */
export function needsReacceptance(userVersion, currentVersion = CURRENT_AGB_VERSION) {
  if (!userVersion) return true;
  const userMajor = String(userVersion).split('.')[0];
  const currentMajor = String(currentVersion).split('.')[0];
  return userMajor !== currentMajor;
}
